@if (isHeader || !device) {
  <th class="icon-cell"></th>
  <th>
    {{ "devices.list.name" | translate }}
  </th>
  <th>
    {{ "devices.list.model" | translate }}
  </th>
  <th>
    {{ "devices.list.power" | translate }}
  </th>
  <!--th>
    {{ 'devices.list.area' | translate }}
  </th-->
  <th>
    {{ "devices.list.currentValue" | translate }}
  </th>
  <th class="icon-cell"></th>
} @else {
  <td class="icon-cell" [class.active]="isActive" [class.pending]="isPending">
    <app-icon [name]="device.type | icons" />
  </td>
  <th [class.active]="isActive" [class.pending]="isPending">
    <div class="flex">
      <span class="line-clamp">{{ device.name }}</span>
      @if (device.isFavorite) {
        <app-icon class="color-favorite" name="ic_star_filled" />
      }
      @if (device.isOutOfService) {
        <app-tag class="ml-2" level="disabled">
          {{ "devices.detail.outOfService.label" | translate }}
        </app-tag>
      }
    </div>
  </th>
  <td [class.active]="isActive" [class.pending]="isPending">
    {{ device.model }}
  </td>
  <td [class.active]="isActive" [class.pending]="isPending">
    <app-power-item
      [powerSource]="device.powerSource"
      [batteryLevel]="device.batteryLevel"
    />
  </td>
  <!--td [class.active]="isActive" [class.pending]="isPending">
    todo Areaname
  </td-->
  <td [class.active]="isActive" [class.pending]="isPending">
    @if (device.isActuator) {
      @if (!hideActions) {
        <app-device-action-trigger
          [disabled]="isInteractionDisabled"
          [isActive]="isActive"
          [isPending]="isDevicePending(device)"
          [transparent]="true"
          (triggerDeviceAction)="onTriggerDeviceAction($event.value)"
        />
      }
    } @else {
      @if (device.value) {
        <p>
          {{ device.value | localizedNumber }}
          @if (device.valueUnit) {
            {{
              LabelConverter.getDeviceValueUnitLabel(device.valueUnit, false)
                | translate
            }}
          }
          <br />
          <small>{{ device.lastSeenDate | relativeDate }}</small>
        </p>
      }
    }
  </td>
  <td class="icon-cell" [class.active]="isActive" [class.pending]="isPending">
    <app-context-menu [menuItems]="contextMenu" />
  </td>
}
